import { CartQuoteActionTypes, CartQuoteEventType } from "@checkout/states";
import type { ChildMachineConfig } from "@checkout/types";
import { CheckoutEvent } from "../../../modules";
import { ActionTypes } from "./actions";
import { GuardTypes } from "./guards";

export const PriceCheck = "priceCheck";

export const getPriceCheckMachine = (config: ChildMachineConfig) => ({
  id: PriceCheck,
  initial: "checkPrice",
  states: {
    checkPrice: {
      always: {
        actions: ActionTypes.checkForPriceChange,
        target: `#${config.parentMachineId}.${PriceCheck}.route`,
      },
    },
    route: {
      always: [
        {
          target: `#${config.parentMachineId}.${PriceCheck}.waiting`,
          cond: GuardTypes.didPriceChange,
        },
        {
          target: config.nextState,
        },
      ],
    },
    waiting: {
      entry: {
        type: ActionTypes.trackPriceChange,
        screen: config.parentMachineId,
      },
      on: {
        [CartQuoteEventType.ACKNOWLEDGE_PRICE_CHANGE]: {
          actions: CartQuoteActionTypes.acknowledgePriceChange,
          target: config.nextState,
        },
        [CheckoutEvent.NEXT]: {
          target: config.nextState,
        },
      },
    },
  },
});
